// constants.js
export const ROUTES = {
  ROOT: "/",
  WORKFORCE: "/workforce",
  ADMIN: "/admin",
  MANAGER: "/manager",
  EMPLOYEE: "/employee",
  CUSTOMERS: "/customers",
  CUSTOMER: "/customer",
  PROSPECT: "/prospect",
  REPORTS: "/reports",
  WASTE: "/waste-manage",
  SUB_CONTRACTOR: "/sub-contractor",
  WORKFORCE_SETTINGS: "/workforce-settings",
  ESTIMATES: "/estimates",
  PROJECT_REGISTER: "/project-register",
  ACTIVITY: "/activity",
  CLIENTS: "/clients",
  PROJECTS: "/projects",
  TASKS: "/tasks",
  ITEMS: "/items",
  TOOLS: "/tools",
  PRODUCTS: "/products",
  REQUEST: "/request",
  RETURN_REQUEST: "/return-request",
  PRODUCT_REQUEST: "/product-request",
  TRANSFER_REQUEST: "/transfer-request",
  AWAITING: "/awaiting",
  MESSAGES: "/messages",
  OHS: "/ohs",
  SUPPORT: "/support",
  ANNOUNCEMENT: "/announcement",
  SETTINGS: "/settings",
  SUMMARY: "/summary",
  WEIGHT_SCALE: "/weight-scale",
  WEIGH_BRIDGE: "/weigh-bridge",
  WEIGHTING_REPORTS: "/weighting-reports",
  VEHICLES: "/vehicles",
  LOAD_TYPE: "/load-type",
  WASTE_TYPE: "/waste-type",
  DAILY_REPORTS: "/daily-reports",
  WORK_DOCKET: "/work-docket",
  ROSTER: "/roster",
  TIME_TRACKING: "/time-tracking",
  TIME_SHEET: "/time-sheet",
  WORK_LOG: "/worklog",
  PAYROLL: "/payroll",
  LEADS: "/leads",
  CASE_2: "/case-2",
  PART_1: "/part-1",
  TASK_CLAIMS: "/task-and-claims",
  TEMPLATE: "/template",
  ANALYTICS: "/analytics",
  INVOICING: "/invoicing",
  CONTRACT_INVOICE: "/contract-invoice",
  DOCKET_INVOICE: "/docket-invoice",
  XERO_INVOICE: "/xero-invoice",
  FLEET: "/fleet",
  DOCUMENT_PARSER: "/document-parser",
  BROWSE_FILE: "/browse-file",
  VIEW_FILE: "/view-file",
  DASHBOARD: "/dashboard",

  // Customer Portal
  USER_MANAGEMENT: "/user-management",
  WARE_HOUSING: "/ware-housing",
  CALENDAR: "/calendar",
  DOCKET_SIGNATURE: "/docket-signature",
  DRIVES: "/drives",
};
